import { memo } from "react";
import Icon, { IconTypes } from "../icon";
import Heading from "../typography/Heading";
import Text from "../typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";

interface SelectedOption {
  name: string;
  description: string;
  price: number;
  calculatedPrice?: number;
}

interface OptionTemplateProps {
  title: string;
  onShowInfoClick?: () => void;
  children?: any;
  className?: string;
  testId?: string;
  description?: string;
  enablePadding?: boolean;
  selected?: SelectedOption | null;
  showInfo?: boolean;
  borderBottom?: boolean;
}
const OptionTemplate = memo(
  ({
    title,
    children,
    className,
    onShowInfoClick,
    testId,
    description,
    selected,
    enablePadding = true,
    showInfo = true,
    borderBottom = true,
  }: OptionTemplateProps) => {
    const priceToDisplay = getFormattedPrice(selected?.calculatedPrice);

    return (
      <div
        className={concatClassnames(
          "gg-border-dark-blue-100",
          enablePadding && "gg-pb-6 gg-pt-8 sm:gg-px-7",
          className,
          borderBottom && "gg-border-b",
        )}
        data-testid={testId}
      >
        <Heading
          headingLevel="h4"
          className="gg-flex !gg-text-base sm:gg-text-lg"
        >
          {title}
          {showInfo && (
            <button
              type="button"
              aria-label={`Meer informatie over ${title}`}
              onClick={onShowInfoClick}
              data-testid="option-info-button"
            >
              <Icon name={IconTypes.INFO} className="gg-ml-2" alt="" />
            </button>
          )}
        </Heading>
        {description && (
          <Text className="gg-mb-4 gg-mt-1 gg-pr-6 gg-text-sm">
            {description}
          </Text>
        )}
        {children}

        {!!selected && (
          <div
            data-testid="layout-options-price-container"
            className="gg-mt-9 gg-bg-grey-500 gg-p-4 gg-text-sm gg-text-dark-blue"
          >
            <header className="gg-mb-2 gg-flex gg-justify-between">
              <Text className="gg-font-bold">
                Huidige keuze: {selected.name}
              </Text>
              <Text
                data-testid="formatted-price"
                className="gg-shrink-0 gg-text-secondary-text"
              >
                +{priceToDisplay}
              </Text>
            </header>
            <Text>{selected.description}</Text>
          </div>
        )}
      </div>
    );
  },
);
export default OptionTemplate;
